import { SubmissionStatus } from "generated-graphql/graphql";

/**
 * Human-readable labels for submission statuses with emoji indicators.
 * Used across Staff and Customer bulk action dialogs for consistent display.
 */
export const STATUS_LABELS: Record<string, string> = {
  [SubmissionStatus.NotStarted]: "🔶 Upcoming",
  [SubmissionStatus.InProgress]: "🚧 In Progress",
  [SubmissionStatus.EncampInitialReview]: "⛺️ In Encamp Review",
  [SubmissionStatus.InReview]: "🔍 In Review",
  [SubmissionStatus.ProcessingSubmission]: "✅ Awaiting Submission",
  [SubmissionStatus.FilingComplete]: "🎉 Submitted",
  [SubmissionStatus.NotReporting]: "⭕️ Not Reporting",
};

/**
 * Statuses where bulk add reviewers and bulk set signer actions are locked.
 * These submissions are too far in the workflow to allow reviewer/signer changes.
 */
export const BULK_ACTION_LOCKED_STATUSES: SubmissionStatus[] = [
  SubmissionStatus.EncampInitialReview,
  SubmissionStatus.InReview,
  SubmissionStatus.ProcessingSubmission,
  SubmissionStatus.FilingComplete,
];

/**
 * Checks if a submission status is locked for bulk reviewer/signer actions.
 */
export function isSubmissionLockedForBulkAction(
  status: SubmissionStatus | string | null | undefined
): boolean {
  if (!status) return false;
  return BULK_ACTION_LOCKED_STATUSES.includes(status as SubmissionStatus);
}
